import { FC, forwardRef } from 'react';
import { Title } from '@smart-kasa/ui';

import { IReceipt } from 'types';

import { Receipt } from './Receipt';
import { ReceiptAlert } from './ReceiptAlert';
import { ReceiptWrapper } from './ReceiptWrapper';
import { ReceiptHeader } from './ReceiptHeader';
import { ReceiptTransaction } from './ReceiptTransaction';
import { ReceiptFooter } from './ReceiptFooter';
import { ReceiptShop } from './ReceiptShop';

type DocumentProps = {
  ref?: any;
  receipt: IReceipt;
  children?: never;
};

export const Document: FC<DocumentProps> = forwardRef<HTMLDivElement, DocumentProps>(
  ({ receipt }, ref) => (
    <ReceiptWrapper ref={ref}>
      {!receipt.fiscalNumber && <ReceiptAlert>НЕ Є РОЗРАХУНКОВИМ ДОКУМЕНТОМ</ReceiptAlert>}

      <ReceiptHeader>
        <Title>{receipt.fiscalNumber ? 'Фіскальний чек' : 'Нефіскальний товарний чек'}</Title>
      </ReceiptHeader>

      {receipt.shop && <ReceiptShop shop={receipt.shop} />}

      <Receipt receipt={receipt}>
        {receipt.paymentTransactions?.map((transaction) => (
          <ReceiptTransaction key={transaction.id} transaction={transaction} />
        ))}
      </Receipt>

      <ReceiptFooter />
    </ReceiptWrapper>
  )
);
